
import langConstants from '../constants/lang';

const changeLang = lang => ({ type: langConstants.CHANGE, lang });


export default changeLang;
